/*
  Click tracking for the pill links in the collection banner (PLP header).

  Pushes `collection_banner_link_click` to the GTM data layer before navigating, so the click
  is captured reliably without appending UTM parameters to the link. Same event name and
  payload as the brand stores that already ship this, so existing GTM triggers keep working:
    { event: 'collection_banner_link_click', link_text, link_url, referring_url }

  Navigation waits for GTM's eventCallback (eventTimeout 1000 is GTM's own cap). The callback
  never fires when GTM is not loaded, so on a store without GTM (or with it blocked) a click
  would not navigate. REVISIT after launch, once Elevar loads GTM: see docs/post-launch-revisit.md
  in the extractor repo.
*/
(function () {
  document.querySelectorAll('.collection-hero__pills').forEach(function (nav) {
    if (nav.dataset.trackingBound) return;
    nav.dataset.trackingBound = 'true';

    nav.addEventListener('click', function (event) {
      var link = event.target.closest('.collection-hero__pill');
      if (!link || !nav.contains(link)) return;

      var modified = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
      var href = link.getAttribute('data-link-url') || link.getAttribute('href');
      var navigated = false;

      function navigate() {
        if (navigated) return;
        navigated = true;
        window.location.href = href;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'collection_banner_link_click',
        link_text: link.getAttribute('data-link-text'),
        link_url: link.getAttribute('data-link-url'),
        referring_url: window.location.href,
        eventCallback: modified ? function () {} : navigate,
        eventTimeout: 1000,
      });

      // Opening in a new tab or window: track, but let the browser do its default.
      if (modified) return;

      event.preventDefault();
    });
  });
})();
